//ManageContractList

import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
//import { ContractService } from "../../../services";
import { StaticPageContentService } from "../../../services";

import Editor from "react-simple-wysiwyg";

import {
  
  handleConsoleError,
} from "../../../utils/common-methods";
import { injectModels } from "../../../redux/injectModels";
//import { injectModels } from "../../../redux/injectModels";

function ManageStaticPageContent(props) {
  const [showModal, setShow] = useState(false);
  const [error, setError] = useState("");
  const [id, setId] = useState("");

  const [title, setName] = useState("");
  const [content, setContractdetails] = useState("");
  const [url, setContractFor] = useState("");

  const [isactive, setIsActive] = useState(false);
  //const [isSignRequire, setIsSignRequire] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);

  const getData = async () => {
     props.application.setLoading(true);
    try {
      const res = await StaticPageContentService.getStaticPageList();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
            props.application.setLoading(false);
      } else {
           props.application.setLoading(false);
           // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
         props.application.setLoading(false);
       const message = handleConsoleError(error);
        toast.error(error?.message || message);
    }
  };

  const handleName = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val?.trim() === "") {
      setError("Name is required");
    } else {
      setError("");
    }
    setName(val);
  };

  const handleContent = (e) => {
    const val = e.target.value;

    if (val?.trim() === "<br>") {
      setError("Static Page Details is required");
    } else {
      setError("");
    }
    setContractdetails(val);
  };

  const handleURL = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val?.trim() === "") {
      setError("url is required");
    } else {
      setError("");
    }
    setContractFor(val);
  };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;

    if (title?.trim() === "") {
      setError("Name is required");
      valid = false;
      return;
    } else {
      setError("");
    }
    if (content?.trim() === "<br>") {
      setError("Static Page Details is required");
      valid = false;
      return;
    } else {
      setError("");
    }

    if (url?.trim() === "<br>") {
      setError("url is required");
      valid = false;
      return;
    } else {
      setError("");
    }
    if (!valid) {
      setError("Please fill all fields");
      return;
    } else {
      setError("  ");
      try {
        const data = {
          title: title?.trim(),
          content: content?.trim(),
          url: url,
          isactive: isactive,
        };

        const res = await StaticPageContentService.updateStaticPage(data);
        if (res?.isSuccess) {
          toast.success(res?.message);
        } else {
          toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        }
        handleClose();
        setId("");
        getData();
      } catch (err) {
        const message = handleConsoleError(err);
        toast.error(err?.message || message);
        setId("");
      }
    }
  };

  const handleEdit = async (url) => {
    try {
      //    props.application.setLoading(true);
      const res = await StaticPageContentService.getStaticPageByUrl(url);

      if (res?.isSuccess) {
        setName(res?.data?.title);
        setContractdetails(res?.data?.content);
        setContractFor(res?.data?.url);
        setIsActive(res?.data?.isActive);
        setId(res?.data?.id);
        handleShow();
        //    props.application.setLoading(false);
      } else {
       toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        //    props.application.setLoading(false);
      }
    } catch (error) {
      //   props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);

    if (filteredData.length === 0) {
      setShowNextButton(false);
    } else if (selected === pageCount - 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel={showPreviousButton ? "Previous" : null}
          nextLabel={showNextButton ? "Next" : null}
          breakLabel="..."
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const tag = e.dataTransfer.getData("text/plain");
    setContractdetails((prev) => prev + ` ${tag} `);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">Static Page</li>
          </ol>
        </nav>
      </div>

      <div className="staticpageModel">
        <Modal
          show={showModal}
          onHide={handleClose}
          backdrop="static"
          className="custom-contract-modal"
        >
          <Modal.Header closeButton className="modal-main-header">
            <Modal.Title>
              {id === "" ? "Add" : "Update"} Static Page
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="searchformfld">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Name"
                  value={title}
                  maxLength="100"
                  onChange={handleName}
                  required
                  disabled
                />
                <label>Content</label>
                <div
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    minHeight: "150px",
                    overflowX: "scroll",
                    maxHeight: "330px",
                  }}
                >
                  <Editor value={content} onChange={handleContent} />
                </div>

                <label className="mt-3">URL</label>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="URL "
                  value={url}
                  maxLength="10"
                  onChange={handleURL}
                  required
                  disabled
                />

                <div className="custom-check" style={{ marginTop: "10px" }}>
                  <label>Status </label>
                  <input
                    type="checkbox"
                    checked={isactive} // Controlled by state
                    onChange={handleIsActive} // Handle change event
                  />
                </div>
              </div>
              {error && <span className="text-danger">{error}</span>}
            </form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              type="submit"
              variant="primary custom-button-colour"
              onClick={handleSubmit}
            >
              {id === "" ? "Save" : "Update"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className="table-responsive">
        <div>
          <h2>Static Page</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Url</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.title}</td>
                      <td>{item?.url} </td>
                      <td className="delete-create">
                        {item?.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>

                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item?.url);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <strong>Total Count: {filteredData.length}</strong>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["application"])(ManageStaticPageContent);

